// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__2MJJt","image":"App_image__aTqUc"};